function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import * as styles from '../styles/select.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var SelectMenu = _ref => {
  var isOpen = _ref.isOpen,
    options = _ref.options,
    highlightedIndex = _ref.highlightedIndex,
    selectedItem = _ref.selectedItem,
    getItemProps = _ref.getItemProps,
    optionComponent = _ref.optionComponent,
    visualState = _ref.visualState,
    dropdownMaxHeight = _ref.dropdownMaxHeight,
    getMenuProps = _ref.getMenuProps,
    inputValue = _ref.inputValue,
    noOptionsMessage = _ref.noOptionsMessage;
  return ___EmotionJSX("div", {
    css: styles.menuOuter(visualState),
    "data-testid": "domain-select-menu-container"
  }, ___EmotionJSX("ul", _extends({
    "data-testid": "domain-select-menu",
    css: styles.menu({
      dropdownMaxHeight
    })
  }, getMenuProps()), isOpen && options.map((item, index) => {
    if (optionComponent) {
      return optionComponent(item, index, highlightedIndex, selectedItem, getItemProps, inputValue);
    }
    var isSelected = highlightedIndex === null && selectedItem === item;
    return ___EmotionJSX("li", getItemProps({
      item,
      index,
      key: item.value,
      css: styles.item(_objectSpread(_objectSpread({}, visualState), {}, {
        isHighlighted: highlightedIndex === index,
        isSelected
      })),
      'aria-selected': isSelected,
      'data-option': item.value
    }), item.label);
  }), isOpen && options.length === 0 && noOptionsMessage ? ___EmotionJSX("li", {
    css: styles.item(_objectSpread(_objectSpread({}, visualState), {}, {
      disabled: true,
      isHighlighted: false,
      isSelected: false
    })),
    role: "option",
    "aria-selected": "false",
    "aria-disabled": "true",
    "data-option": "no-options"
  }, noOptionsMessage) : null));
};
export default SelectMenu;